import type { Release } from '../releases';

export default {
  id: '2026-11-02-delegation-money-approvals',
  at: '2026-11-02T07:33:00Z',
  title: 'Замещение: согласования с суммами — только заместителю, который видит суммы',
  modules: ['admin'],
  items: [
    'Если владелец портала не выдал заместителю уровень денег не ниже наибольшего уровня замещаемого, согласования и решения о деньгах замещаемого к заместителю не переходят: договоры и их подпись, выбор поставщика сверх лимита, факт оплаты, бюджет, смета, запросы на изменение, складские решения о недостачах, факт оплаты, решения финансового менеджера, а также управление людьми и ролями — через него можно выдать себе любое из этих прав. Их решают другие согласующие с тем же правом.',
    'Остальные права замещаемого заместитель получает, как раньше; свои права согласования у него остаются.',
    'Об этом сказано в письме о назначении замещения и в подсказке на странице «Администрирование → Замещения».',
  ],
  why: 'Заместитель без доступа к суммам мог согласовать договор или оплату, не видя денег. Теперь решение о деньгах принимает тот, кто их видит.',
  link: '/admin/delegations',
} satisfies Release;
